import axios from 'axios';
import * as types from '../constants/ActionTypes';
import { PayPayCredit } from '../constants/UtilVariables';
import { getCountry } from '../../lib/page';

const PPC_ENABLE_URL = 'ppcredit-checker';
const country = getCountry();

// PayPal Credit enable checker logic
function PPCEnableChecker(response) {
  if (response && response.credit_accounts) {
    return Array.isArray(response.credit_accounts) &&
      response.credit_accounts.some(account => (
        account.type === PayPayCredit.accountMapping[country]
      ));
  }
  return false;
}

// Fetch PPCredit Account info for login user
function requestPPCEnable() {
  return {
    type: types.REQUEST_PPC_ENABLE,
  };
}

function receivePPCEnable(responseData) {
  return {
    type: types.RECEIVE_PPC_ENABLE,
    payload: PPCEnableChecker(responseData),
  };
}

function receivePPCEnableError() {
  return {
    type: types.RECEIVE_PPC_ENABLE_ERROR,
  };
}

function fetchPPCEnable() {
  return (dispatch) => {
    dispatch(requestPPCEnable());
    return axios.get(PPC_ENABLE_URL)
      .then((response) => {
        dispatch(receivePPCEnable(response.data));
      })
      .catch(() => {
        dispatch(receivePPCEnableError());
      });
  };
}

export default {
  fetchPPCEnable,
};
